import { Component, createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import { Ncs, PartialNcsConfig, mergePartialConfigs } from 'ncs'
import { ncsConfig } from '../components/search/ncs_config'
import App from '../components/search/Form.vue'
import KwicHeader from '../components/search/KwicHeader.vue'
import ContextDocumentHeader from '../components/search/ContextDocumentHeader.vue'

declare global {
  interface Window {
    gon: any
  }
}

const components: Record<string, Component> = {
  NcsKwicResultHeader: KwicHeader,
  NcsContextDocumentHeader: ContextDocumentHeader,
}

const serverConfig = window.gon.config as PartialNcsConfig
const config = mergePartialConfigs(serverConfig, ncsConfig)

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: serverConfig.i18n.locale,
  messages: { [config.i18n.locale]: config.i18n.messages }
})

const mountApplication = () => {
  const main = document.getElementById('search')
  if (!main) return

  const pinia = createPinia()
  const app = createApp(App)
    .use(i18n)
    .use(pinia)
    .use(Ncs, { config, components })

  const el = main.appendChild(document.createElement('div'))
  app.mount(el)

  document.addEventListener('turbo:before-cache', () => app.unmount(), { once: true })
}

document.addEventListener('turbo:render', mountApplication)

mountApplication() // Trigger when script is first loaded
